import { cn } from "@/lib/utils";

export function LoadingBlock({
  label = "Loading content",
  className,
}: {
  label?: string;
  className?: string;
}) {
  return (
    <div className={cn("w-full animate-pulse py-6", className)} role="status" aria-live="polite">
      <span className="sr-only">{label}</span>
      <div aria-hidden className="grid gap-5 sm:grid-cols-2 lg:grid-cols-3">
        {[0, 1, 2].map((item) => (
          <div key={item} className="overflow-hidden rounded-md border border-border/70 bg-card">
            <div className="aspect-[16/9] bg-slate-200" />
            <div className="space-y-3 p-4">
              <div className="h-3 w-1/3 rounded bg-slate-200" />
              <div className="h-5 w-4/5 rounded bg-slate-200" />
              <div className="h-3 w-full rounded bg-slate-100" />
              <div className="h-3 w-2/3 rounded bg-slate-100" />
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}

export function EmptyBlock({
  title,
  description,
  action,
  className,
}: {
  title: string;
  description?: string;
  action?: React.ReactNode;
  className?: string;
}) {
  return (
    <div
      className={cn(
        "rounded-md border border-dashed border-border bg-off-white/60 p-8 text-center",
        className,
      )}
    >
      <p className="text-display text-xl uppercase text-navy">{title}</p>
      {description ? (
        <p className="mx-auto mt-1 max-w-md text-sm text-muted-foreground">{description}</p>
      ) : null}
      {action ? <div className="mt-4 flex justify-center">{action}</div> : null}
    </div>
  );
}

export function ErrorBlock({ error, className }: { error: unknown; className?: string }) {
  const msg = error instanceof Error ? error.message : "Something went wrong.";
  return (
    <div
      role="alert"
      className={cn(
        "rounded-md border border-destructive/30 bg-destructive/5 p-4 text-sm text-destructive",
        className,
      )}
    >
      {msg}
    </div>
  );
}
